import type { KeyBind } from '@usealloy/component-library';

export const keyBinds: KeyBind[] = [
  {
    key: 'ArrowLeft',
    direction: 'prev',
  },
  {
    key: 'ArrowRight',
    direction: 'next',
  },
];
